import { useMemo } from 'react';
import { Box, Flex, Paragraph } from 'theme-ui';

import { Link } from '@snippets';

import { themed } from './SizeOptions.theme';

export const SizeOptions = themed(({ theme, product }) => {
  const options = product?.toggles?.size;

  const selectedSize = useMemo(
    () => product?.title?.split('|')[2]?.trim() || null,
    [product?.id]
  );

  return options?.length ? (
    <Box data-comp={SizeOptions.displayName} sx={theme.option}>
      <Flex sx={theme.header}>
        <Paragraph sx={theme.name}>Size</Paragraph>
        <Paragraph sx={theme.size}>{selectedSize}</Paragraph>
      </Flex>

      <Flex as="ul" sx={theme.values}>
        {options.map(({ title, handle, url }) => {
          const isSelected = product.handle === handle;
          return (
            <Box as="li" key={handle}>
              <Link
                href={url}
                onClick={(e) => {
                  if (isSelected) e.preventDefault();
                }}
                sx={{
                  ...theme.value,
                  ...(isSelected
                    ? theme.value.available.selected
                    : theme.value.available.unselected),
                }}
              >
                {title}
              </Link>
            </Box>
          );
        })}
      </Flex>
    </Box>
  ) : null;
});

SizeOptions.displayName = 'SizeOptions';
